// alternative-dashboard\alternative-components\CFOCopilot\CFOInsightsDailyBrief.tsx
import { ICON_BASE_PATH } from "@/app/utils/config";

interface CFOInsightsDailyBriefProps {
  title?: string;
}

function CFOInsightsDailyBrief({ title }: CFOInsightsDailyBriefProps) {
  return (
    <div className="gx-cfo-daily-brief-main">
      <div className="gx-cfo-daily-brief-content">
        <div className="gx-cfo-daily-brief-img-header">
          <img src={`${ICON_BASE_PATH}cobilot.svg`} alt="cobilot" />
          <h1 className="gx-cfo-daily-header gx-p16-b">
            {title || "CFO Insights · daily brief"}
          </h1>
        </div>

        <p className="gx-cfo-daily-brief-paragraph gx-p16-m">
          Cash is healthy at AED 722,723. A AED 18,150 card payment is due in 2
          days - covering it leaves a comfortable buffer. 5 vendor payments (AED
          3,152) are stuck pending consent; clearing them today avoids supplier
          delays.
        </p>
      </div>
    </div>
  );
}

export default CFOInsightsDailyBrief;
